import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './_card.css'
import StatRollup from './StatRollup'
import messages from './messages'

function Comparison (props) {
  const {
    activeCards,
    id,
    comparison,
    showProfileImage,
    username,
  } = props

  const isActive = activeCards.includes(id)
  const { comparisonUnit, comparisonStat } = messages[id]
  const isNumber = typeof comparison.value === 'number'
  const hasUnitMessage = Boolean(comparisonUnit)
  const hasStatMessage = Boolean(comparisonStat)

  const comparisonNumber = isNumber ?
    <StatRollup
      isActive={isActive}
      stat={comparison.value}
      format={ { maximumFractionDigits: 0 } }
    /> : null

  const comparisonValue = isNumber && hasUnitMessage ?
    <div className={styles.cardComparisonValue}>
      <h2>{comparisonNumber}</h2>
      <p>
        { comparisonUnit ? <FormattedMessage {...comparisonUnit} /> : null }
      </p>
    </div> : hasStatMessage ?
      <div className={styles.cardComparisonValue}>
        <FormattedHTMLMessage {...comparisonStat} />
      </div>
    : null

  return (
    <div className={styles.cardComparison}>
      { showProfileImage ?
        <div className={styles.profileImage}>
          <img src={`/profile/${username}/picture?size=Medium`} />
        </div>
      : null }
      <div className={styles.cardComparisonIcon}>
        { comparison.gradient ? <img className={styles.iconGradient} src={comparison.gradient} /> : null }
        { comparison.light ? <img className={styles.iconLight} src={comparison.light} /> : null }
      </div>
      { comparisonValue }
    </div>
  )
}

Comparison.propTypes = {
  activeCards: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  comparison: PropTypes.object,
  showProfileImage: PropTypes.bool,
  username: PropTypes.string,
}

export default Comparison



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Card/Comparison.jsx